import { Link } from 'react-router-dom';

export default function Footer() {
  const socialLinks = [
    {
      name: 'TikTok',
      icon: 'ri-tiktok-fill',
      url: 'https://www.tiktok.com/@aireuniversity',
      shareUrl: 'https://www.tiktok.com/@aireuniversity/video/7234567890123456789',
      color: 'hover:bg-[#000000]'
    },
    {
      name: 'Instagram',
      icon: 'ri-instagram-line',
      url: 'https://www.instagram.com/aireuniversity',
      shareUrl: 'https://www.instagram.com/p/ABC123xyz/',
      color: 'hover:bg-gradient-to-br hover:from-[#833AB4] hover:via-[#FD1D1D] hover:to-[#F77737]'
    },
    {
      name: 'Facebook',
      icon: 'ri-facebook-fill',
      url: 'https://www.facebook.com/aireuniversity',
      shareUrl: 'https://www.facebook.com/aireuniversity/posts/123456789',
      color: 'hover:bg-[#1877F2]'
    },
    {
      name: 'Pinterest',
      icon: 'ri-pinterest-fill',
      url: 'https://www.pinterest.com/aireuniversity',
      shareUrl: 'https://www.pinterest.com/pin/123456789/',
      color: 'hover:bg-[#E60023]'
    },
    {
      name: 'YouTube',
      icon: 'ri-youtube-fill',
      url: 'https://www.youtube.com/@aireuniversity',
      shareUrl: 'https://www.youtube.com/watch?v=dQw4w9WgXcQ',
      color: 'hover:bg-[#FF0000]'
    },
    {
      name: 'LinkedIn',
      icon: 'ri-linkedin-fill',
      url: 'https://www.linkedin.com/company/aireuniversity',
      shareUrl: 'https://www.linkedin.com/feed/update/urn:li:activity:1234567890',
      color: 'hover:bg-[#0A66C2]'
    },
    {
      name: 'Twitter',
      icon: 'ri-twitter-x-fill',
      url: 'https://twitter.com/aireuniversity',
      shareUrl: 'https://twitter.com/aireuniversity/status/1234567890',
      color: 'hover:bg-[#000000]'
    }
  ];

  return (
    <footer className="bg-[#1A2332] text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="flex items-center gap-2 mb-6">
              <div className="w-10 h-10 bg-[#FF6B6B] rounded-lg flex items-center justify-center">
                <i className="ri-home-heart-line text-white text-xl"></i>
              </div>
              <span className="text-2xl font-bold" style={{ fontFamily: 'Playfair Display, serif' }}>
                Aire University
              </span>
            </div>
            <p className="text-gray-400 leading-relaxed mb-6">
              Your trusted partner in transforming properties into successful short-term rental businesses.
            </p>
            
            {/* Contact Info */}
            <div className="space-y-2 text-sm text-gray-400">
              <p className="flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                2043 Pulaski Hwy, Newark, DE 19702
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <a href="tel:302-500-3373" className="hover:text-white transition-colors cursor-pointer">302-500-3373</a>
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <a href="mailto:Aireuniversity@gmail.com" className="hover:text-white transition-colors cursor-pointer">Aireuniversity@gmail.com</a>
              </p>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">Services</h3>
            <ul className="space-y-3">
              <li><Link to="/services" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Silver Package</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Gold Package</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Platinum Package</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Training Programs</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Property Management</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">Company</h3>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-gray-400 hover:text-white transition-colors cursor-pointer">About Us</Link></li>
              <li><Link to="/gallery" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Gallery</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Contact</Link></li>
              <li><Link to="/" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Testimonials</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-4">Follow Us</h3>
            <p className="text-gray-400 text-sm mb-4">Stay connected for tips, transformations, and success stories!</p>
            <div className="flex flex-wrap gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`w-10 h-10 bg-white/10 rounded-lg flex items-center justify-center transition-all duration-300 cursor-pointer ${social.color}`}
                  title={`Follow us on ${social.name}`}
                >
                  <i className={`${social.icon} text-xl`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © 2025 Aire University. All rights reserved.
          </p>
          <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
